import React, { Component } from 'react';
import { Link } from 'react-router';


class Book extends Component {
  constructor() {
    super();
    this.handleModal = this.handleModal.bind(this);
    this.state = {
      showModal: false
    }
  }

  handleModal (e) {
    e.preventDefault();
    this.props.onClick(this.props.book);
  }

  render() {
    let keywordsComponents,
        path;
    if (this.props.book.Keywords && this.props.book.Keywords.map) {
      keywordsComponents = this.props.book.Keywords.map((keyword, index) => {
        if (index < 3) {
          path = `/keywords/${keyword}`;
          return <Link to={path} key={index} className="btn btn-xs btn-warning keyword-button">{keyword}</Link>;
        }
        return null;
      })
    }
    return (
      <tr key={this.props.index} >
        <td className="col-sm-6"><a href="#" onClick={this.handleModal}>{this.props.book.Title}</a></td>
        <td className="col-sm-3">{this.props.book.Author}</td>
        <td className="col-sm-3">{keywordsComponents}</td>
      </tr>
    )
  }

}

export default Book;



/** WEBPACK FOOTER **
 ** ./src/components/Books/Book.js
 **/